import { render, staticRenderFns } from "./GenerateReports.vue?vue&type=template&id=6b8dd710&scoped=true&"
import script from "./GenerateReports.vue?vue&type=script&lang=js&"
export * from "./GenerateReports.vue?vue&type=script&lang=js&"
import style0 from "./GenerateReports.vue?vue&type=style&index=0&id=6b8dd710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8dd710",
  null
  
)

export default component.exports